import React, { ReactNode } from 'react';
import classNames from 'classnames';

export interface BodyProps {
  children: ReactNode;
  className?: string;
  id?: string;
}

const Body = ({ children, className, id }: BodyProps): JSX.Element => (
  <div id={id} className={classNames('ver-accordion-card__body usa-card__body', className)}>
    {children}
  </div>
);

export default Body;
